module.exports = __webpack_public_path__ + "fonts/SFUIText-SemiboldItalic.8c0876cf.woff2";